<div class="form-builder">
    <div class="buttons">
        <mat-checkbox [(ngModel)]="this.SiteHomePage.showPublishFolderButton"
                      [checked]="this.SiteHomePage.showPublishFolderButton"
                      name="chkShowPublishFolderButton"
                      title="Show Publish Folder Button?">Show Publish Folder Button?</mat-checkbox>&nbsp;

        <mat-checkbox [(ngModel)]="this.SiteHomePage.showSubscribeToFolderButton"
                      [checked]="this.SiteHomePage.showSubscribeToFolderButton"
                      name="chkShowSubscribeToFolderButton"
                      title="Show Subscribe to Folder Button?">Show Subscribe to Folder Button?</mat-checkbox>
    </div>
    <ng-container *ngIf="this.FormBuilderAssistant != null">
        <app-form-builder #formBuilder
                          [fieldDefinitions]="this.FieldDefinitions"
                          [form]="this.Form"
                          [formBuilderAssistant]="this.FormBuilderAssistant"
                          (onSave)="this.saveHomePage($event)"></app-form-builder>
    </ng-container>
</div>
